export default __webpack_public_path__ + "static/cart_center-18557b7f16cfa9383788c8ae851ea6ba.png";